<template>
  <table-component />
</template>
<script>
  import TableComponent from '@autocaller_v2/components/webhook-table.vue';

  export default {
    components: { TableComponent }
  };
</script>
